module.exports = __webpack_public_path__ + "img/health-coach-mobile.ea541ca9.png";